import PropTypes from "prop-types"

const Card = ({ header, children, footer, className = "" }) => {
  return (
    <div
      className={`bg-white shadow-md rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg border border-gray-100 ${className}`}
    >
      {header && <div className="px-5 py-4 border-b border-gray-100 bg-gray-50">{header}</div>}
      <div className="p-5">{children}</div>
      {footer && <div className="px-5 py-4 border-t border-gray-100 bg-gray-50">{footer}</div>}
    </div>
  )
}

Card.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  className: PropTypes.string,
}

export default Card
